


































































































































import BaseFilter from "@/components/Filter/BaseFilter";
import FilterSelectedItemWings from "@/components/Filter/FilterSelectedItemWings.vue";
import { Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { DatePickerWings, FastDateGroupWings, FilterWings, SelectWings, NumberWings } from "@/components";
import { beginningOfCurrentDay, currentDateEnd, dateFilter } from "@/utils/date-util";
import { Action, Getter, Mutation } from "vuex-class";
import { GroupFilterParams } from "@/store/email/statistic/types";
import {notifyError, notifyWarning} from '@/utils/notify-helper';
import { MsgTransports } from '@/store/types';

@Component({
  components: {FilterSelectedItemWings, SelectWings, FilterWings, DatePickerWings, FastDateGroupWings, NumberWings},
  filters: {dateFilter}
})
export default class EmailGroupFilter extends BaseFilter<GroupFilterParams> {

  @PropSync('show') is_show!: boolean;
  @PropSync("filterClone") propFilterClone!: any;

  @Mutation('setEmailStatisticGroup') setStatistic: any

  @Action("getEmailStatisticGroup") actionGetStatistic: any;
  @Action("exportEmailStatisticGroup") actionExport: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action("getOriginators") actionGetOriginators: any;

  @Getter("emailGroupBy") groupByList: any;
  @Getter("emailGroupByOptionally") optionallyGroupByList: any;
  @Getter("messageTypes") messageTypesList: any;
  @Getter("originators") originatorsList: any;

  groupBy = null;
  optionallyGroupBy = null;

  defaultFilter(): GroupFilterParams {
    return new GroupFilterParams(beginningOfCurrentDay(), currentDateEnd(), "day");
  }

  parseGroupBy() {
    if (this.filter.group_by.length == 0) return

    this.filter.group_by.split(',').forEach((item:any) => {
      if (this.groupByList.includes(item)) this.groupBy = item;
      else this.optionallyGroupBy = item;
    })
  }

  mergeGroupBy() {
    this.filter.group_by = [this.groupBy, this.optionallyGroupBy].filter(item => item).join(',')
    this.$set(this.sendFilter, 'group_by', this.filter.group_by);
    this.$emit('onGroupByChange', {groupBy: this.groupBy, optionallyGroupBy: this.optionallyGroupBy})
  }

  created() {
    this.setStatistic(null)
    this.actionGetOriginators({transport: MsgTransports.EMAIL});
    this.actionGetMessageTypes()
    this.parseGroupBy()
  }

  async onFilteredAction() {
    this.setStatistic(null)
    this.mergeGroupBy()
    try {
      const resp = await this.actionGetStatistic(this.filter);
      if (resp.status == 204) {
        notifyWarning()
      }
    } catch(err) {
      notifyError(err)
    }
  }

  // Override
  async doActionExport() {
    this.mergeGroupBy()
    return await this.actionExport(this.sendFilter);
  }

  @Watch('filter', { immediate: true, deep: true })
  onFilterChanged(newVal: GroupFilterParams) {
    this.propFilterClone = newVal;
  }
}
